import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import {HttpGet} from "../common/HttpRequestBuilder";

const SUBSCRIPTION_KEY = environment.notification_service_baseUrl.subscriptionKey;

const getNotificationList = (parameters) => {

    let query_params = parameters;
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.LIST_NOTIFICATION, query_params, subscriptionKey);
    return result;
}

const NotificationService = {
    getNotificationList,
}

export default NotificationService
